import React, { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Updationplan = () => {
    const [mobileNo, setMobileNo] = useState('');
    const [type, setType] = useState('');
    const [paymentMode, setPaymentMode] = useState('');
    const [transactionNo, setTransactionNo] = useState('');
    const [transactionDate, setTransactionDate] = useState('');
    const [plans, setPlans] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState('');
    const [planDetails, setPlanDetails] = useState(null);
    const [userId, setUserId] = useState(null);
    const [name, setName] = useState('');
    const [currentPlan, setCurrentPlan] = useState(null);
    const [paymentModes, setPaymentModes] = useState([]); // New state for payment modes



    useEffect(() => {
        // Fetch available payment modes
        fetch(`${API_BASE_URL}/api/payment_modes`)
            .then(response => response.json())
            .then(data => setPaymentModes(data))
            .catch(error => console.error('Error fetching payment modes:', error));

        // Fetch plans based on type
        if (type) {
            fetch(`${API_BASE_URL}/api/plans?type=${type}&is_active=1`)
                .then(response => response.json())
                .then(data => setPlans(data))
                .catch(error => console.error('Error fetching plans:', error));
        } else {
            setPlans([]);
        }
    }, [type]);

    const handleSearch = async (e) => {
        e.preventDefault();
        
        try {
            const response = await fetch(`${API_BASE_URL}/api/updatepayments/search_payment?mobileno=${mobileNo}&type=${type}`);
            const result = await response.json();
            
            if (response.ok) {
                setUserId(result.userId);
                setName(result.name);
                setPlanDetails(result.planDetails);
                setPaymentMode(result.planDetails.payment_mode);
                setTransactionNo(result.planDetails.TXN_ID);
                setTransactionDate(result.planDetails.TXN_DATE);
                setSelectedPlan(result.planDetails.planid.toString());
    
                const planResponse = await fetch(`${API_BASE_URL}/api/plans/${result.planDetails.planid}`);
                const planData = await planResponse.json();
    
                if (planResponse.ok) {
                    setCurrentPlan(planData);
                } else {
                    alert(planData.error);
                }
    
            } else {
                alert(result.error);
            }
        } catch (error) {
            console.error('Error searching user:', error);
        }
    };
    



    const handleUpdate = async (e) => {
        e.preventDefault();
        
        if (!userId) {
            alert('No user found to update.');
            return;
        }
    
        const selectedPlanData = plans.find(plan => plan.id.toString() === selectedPlan);
    
        if (!selectedPlanData) {
            alert('Please select a valid plan.');
            return;
        }
    
        const updatedData = {
            userId,
            paymentMode,
            txnId: transactionNo,
            txnDate: transactionDate,
            actualAmount: selectedPlanData.original,
            gstAmount: selectedPlanData.gstAmount,
            totalAmount: selectedPlanData.totalPayable,
            validity: selectedPlanData.validity_days,
            planid: selectedPlanData.id,
        };
    
        try {
            const response = await fetch(`${API_BASE_URL}/api/payments/update_payment`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updatedData),
            });
    
            const result = await response.json();
            
            if (response.ok) {
                alert('Plan updated successfully');
                
                // Refresh the page after a short delay
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                alert(result.error);
            }
        } catch (error) {
            console.error('Error updating plan:', error);
        }
    };

    return (
        <div className="bg-gray-100 p-6">
            <div className="max-w-3xl mx-auto mt-12 bg-white shadow-lg rounded-lg p-8">
                <h1 className="text-2xl font-semibold text-blue-600 mb-6">Update Payment Plan</h1>
                <form onSubmit={handleSearch} className="mb-8 space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Mobile No<span className="text-red-500">*</span></label>
                        <input
                            type="text"
                            value={mobileNo}
                            onChange={(e) => setMobileNo(e.target.value)}
                            required
                            className="w-full p-2 border border-gray-300 rounded-md"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Type</label>
                        <select
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            required
                            className="w-full p-2 border border-gray-300 rounded-md"
                        >
                            <option value="">Select Type</option>
                            <option value="ஜோதிடர்">ஜோதிடர்</option>
                                <option value="ஐயர்">ஐயர்</option>
                                <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
                                <option value="எண்கணிதம்">எண்கணிதம்</option>
                                <option value="சிற்பி">சிற்பி</option>
                                <option value="விபூதி தயாரிப்பவர்">விபூதி தயாரிப்பவர்</option>
                                <option value="ஆன்மீக சொற்பொழிவாளர்">ஆன்மீக சொற்பொழிவாளர்</option>
                                <option value="திருவிழா அலங்காரம் செய்பவர்">திருவிழா அலங்காரம் செய்பவர்</option>
                                <option value="சிற்பி / ஸ்தபதி">சிற்பி / ஸ்தபதி</option>
                                <option value="அலங்காரம் செய்பவர்">அலங்காரம் செய்பவர்</option>
                        </select>
                    </div>
                    <button type="submit" className="w-full bg-blue-500 text-white font-bold py-2 rounded hover:bg-blue-600">Search User</button>
                </form>

{currentPlan && (
    <div className="mt-6 p-4 border border-gray-300 rounded-md">
        <h2 className="text-lg font-semibold">Current Plan</h2>
        <p className="text-gray-700">
            {`Plan: ${currentPlan.name} + ${currentPlan.gst_percent}% | Plan Amount: ₹${currentPlan.original} | GST Amount: ₹${(currentPlan.original * currentPlan.gst_percent / 100).toFixed(2)} | Total Payable: ₹${(currentPlan.original + (currentPlan.original * currentPlan.gst_percent / 100)).toFixed(2)} | Validity: ${currentPlan.validity_days} days`}
        </p>
    </div>
)}

{planDetails && (
                    <form onSubmit={handleUpdate} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Transaction ID</label>
                            <input
                                type="text"
                                value={transactionNo}
                                onChange={(e) => setTransactionNo(e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded-md"
                                readOnly
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Payment Mode</label>
                            <select
                                value={paymentMode}
                                onChange={(e) => setPaymentMode(e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded-md"
                            >
                                <option value="">Select Payment Mode</option>
                                {paymentModes.map((mode) => (
                                    <option key={mode.id} value={mode.id}>
                                        {mode.payment_mode}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Transaction Date</label>
                            <input
                                type="date"
                                value={transactionDate}
                                onChange={(e) => setTransactionDate(e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded-md"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">Select Plan</label>
                            {plans.map((plan) => (
                                <div key={plan.id} className="mt-2">
                                    <label className="inline-flex items-center">
                                        <input
                                            type="radio"
                                            name="plan"
                                            value={plan.id.toString()}
                                            checked={selectedPlan === plan.id.toString()}
                                            onChange={(e) => setSelectedPlan(e.target.value)}
                                            className="form-radio text-green-600"
                                        />
                                        <span className="ml-3 text-red-600">
                                            {`${plan.name} | Plan Amount: ₹${plan.original} | GST Amount: ₹${plan.gstAmount} | Total Payable: ₹${plan.totalPayable} | Validity: ${plan.validity_days} days`}
                                        </span>
                                    </label>
                                </div>
                            ))}
                        </div>
                        <button type="submit" className="w-full bg-green-500 text-white font-bold py-2 rounded hover:bg-green-600">Update Payment Details</button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default Updationplan